/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ICycleDay } from 'app/shared/model/cycle-day.model';
import { TemperatureType } from 'app/shared/model/enumerations/temperature-type.model';

export interface ITemperature {
  id?: string;
  value?: number | null;
  time?: number | null;
  type?: keyof typeof TemperatureType | null;
  comments?: string | null;
  forJanani?: boolean | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  cycleDay?: ICycleDay | null;
}

export const defaultValue: Readonly<ITemperature> = {
  forJanani: false,
  active: false,
  draft: false,
};
